
import ApiSetting from '@/request/api/setting'
import axios from '@/request/http'
import querystring from 'querystring'

const todayRecommendConfigApi = {
  list (params) {
    return axios.get(`${ApiSetting.baseUrl}/api/todayrecommends-config/`, {params: params})
  },
  detail (todayRecommendConfigId, params) {
    return axios.get(`${ApiSetting.baseUrl}/api/todayrecommends-config/${todayRecommendConfigId}/`, {params: params})
  },
  update (todayRecommendConfigId, params) {
    return axios.put(
      `${ApiSetting.baseUrl}/api/todayrecommends-config/${todayRecommendConfigId}/`, querystring.stringify(params))
  },
}

export default todayRecommendConfigApi
